import { jsx as _jsx } from "react/jsx-runtime";
var CrehanaIso = function CrehanaIso(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#4B22F4' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      d: "M8 0H0v8h8v8H0v8h8v-8h8v8h8V0h-8v8H8V0Z",
      fill: color
    })
  });
};
export default CrehanaIso;